/* js/components/SimpleMarkerLibre.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	attr,
	binding_callbacks,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	src_url_equal,
	toggle_class
} from "svelte/internal";

import { onMount, onDestroy } from 'svelte';

// import mapboxgl from "mapbox-gl";
import maplibregl from 'maplibre-gl';

import { getContext, createEventDispatcher } from 'svelte';
import { appRouter } from '../appRouter.js';
import { key } from '../maplibre.js';
import { genevaCoords, createGeoJSONCircle } from '../geoUtils.js';

function create_fragment(ctx) {
	let img;
	let img_src_value;
	let img_style_value;
	let mounted;
	let dispose;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*markerUrl*/ ctx[4]))) attr(img, "src", img_src_value);
			attr(img, "style", img_style_value = `z-index:${/*zIndex*/ ctx[1]}`);
			attr(img, "class", "spot-marker svelte-144gi9y");
			attr(img, "alt", "spot marker");
			toggle_class(img, "clickable", /*clickable*/ ctx[2]);
			toggle_class(img, "big", /*big*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, img, anchor);
			/*img_binding*/ ctx[10](img);

			if (!mounted) {
				dispose = listen(img, "click", /*onClick*/ ctx[5]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*zIndex*/ 2 && img_style_value !== (img_style_value = `z-index:${/*zIndex*/ ctx[1]}`)) {
				attr(img, "style", img_style_value);
			}

			if (dirty & /*clickable*/ 4) {
				toggle_class(img, "clickable", /*clickable*/ ctx[2]);
			}

			if (dirty & /*big*/ 1) {
				toggle_class(img, "big", /*big*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(img);
			/*img_binding*/ ctx[10](null);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { index } = $$props;
	let { big = false } = $$props;
	let { coords } = $$props;
	let { zIndex = 1 } = $$props;
	let { showRadius = false } = $$props;
	let { radiusMeters = 35 } = $$props;
	let { clickable = false } = $$props;
	let markerElement;
	let marker;
	const { getMap } = getContext(key);
	const map = getMap();
	const dispatch = createEventDispatcher();
	const markerUrl = `/markers/simple_hypercity_marker.svg`;

	onMount(() => {
		const options = { element: markerElement, anchor: 'center' };
		marker = new maplibregl.Marker(options).setLngLat(coords).addTo(map);

		if (showRadius) {
			const radiusLayerId = `radius_${index}`;
			const radiusAsKm = radiusMeters / 1000;
			map.addSource(radiusLayerId, createGeoJSONCircle(coords, radiusAsKm));

			map.addLayer({
				"id": radiusLayerId,
				"type": "fill",
				"source": radiusLayerId,
				"layout": {},
				"minzoom": 14,
				"visibility": "visible",
				"paint": {
					"fill-color": "white",
					"fill-opacity": 0.35
				}
			});
		}
	});

	onDestroy(() => {
		if (marker) {
			// console.log("removing marker with id", id);
			marker.remove();
		}
	});

	function onClick() {
		if (clickable) {
			dispatch('requestSelection', {});
		}
	}

	function img_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			markerElement = $$value;
			$$invalidate(3, markerElement);
		});
	}

	$$self.$$set = $$props => {
		if ('index' in $$props) $$invalidate(6, index = $$props.index);
		if ('big' in $$props) $$invalidate(0, big = $$props.big);
		if ('coords' in $$props) $$invalidate(7, coords = $$props.coords);
		if ('zIndex' in $$props) $$invalidate(1, zIndex = $$props.zIndex);
		if ('showRadius' in $$props) $$invalidate(8, showRadius = $$props.showRadius);
		if ('radiusMeters' in $$props) $$invalidate(9, radiusMeters = $$props.radiusMeters);
		if ('clickable' in $$props) $$invalidate(2, clickable = $$props.clickable);
	};

	return [
		big,
		zIndex,
		clickable,
		markerElement,
		markerUrl,
		onClick,
		index,
		coords,
		showRadius,
		radiusMeters,
		img_binding
	];
}

class SimpleMarkerLibre extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			index: 6,
			big: 0,
			coords: 7,
			zIndex: 1,
			showRadius: 8,
			radiusMeters: 9,
			clickable: 2
		});
	}
}

export default SimpleMarkerLibre;